import { Card, Stack, StackSeparator } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { MapColoringLegend } from "../MapColoring/MapColoringLegend";
import { ToggleVisibilityButton } from "../../ToggleVisibilityButton";
import { MapComponent } from "../../../../survey/stores/MapStore";
import { useStores } from "../../../../shared/stores/RootStore";

const MapLegendBase = () => {
  const { mapStore, surveyStore } = useStores();

  return (
    <Card.Root top={2} left={2} position="absolute" zIndex={1}>
      <Stack direction="row" minH="50px">
        {mapStore.componentVisibility.legend && (
          <Stack py={2} px={3} maxW="200px" separator={<StackSeparator />}>
            <MapColoringLegend
              coloring={mapStore.coloring}
              speedUnit={surveyStore.speedUnitStr}
            />
          </Stack>
        )}
        <ToggleVisibilityButton
          component={MapComponent.Legend}
          arrowAngleWhenOpen={180}
        />
      </Stack>
    </Card.Root>
  );
};

export const MapLegend = observer(MapLegendBase);
